import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
};

export type AnalystPerformance = PerformanceMetrics & {
  __typename?: 'AnalystPerformance';
  dailyVelocity: Scalars['Float']['output'];
  errorBreakdown: Array<ErrorSlice>;
  orgId: Scalars['ID']['output'];
  performancePercent: Scalars['Float']['output'];
  personEmail?: Maybe<Scalars['String']['output']>;
  personId: Scalars['ID']['output'];
  personName: Scalars['String']['output'];
  scorePerformance: Scalars['Float']['output'];
  totalCorrect: Scalars['Int']['output'];
  totalDatapoints: Scalars['Int']['output'];
  totalDocuments: Scalars['Int']['output'];
  totalErrors: Scalars['Int']['output'];
  totalFields: Scalars['Int']['output'];
  workDays: Scalars['Int']['output'];
};

export type ClassificationInput = {
  artifactId?: InputMaybe<Scalars['ID']['input']>;
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  continueOnError?: InputMaybe<Scalars['Boolean']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  parallel?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClassificationResult = {
  __typename?: 'ClassificationResult';
  byType: Array<ClassificationTypeCount>;
  chunks?: Maybe<Scalars['Int']['output']>;
  classified: Scalars['Int']['output'];
  dryRun: Scalars['Boolean']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  failed: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
};

export enum ClassificationType {
  CORRECT = 'CORRECT',
  FORMATTING_ERROR = 'FORMATTING_ERROR',
  INCORRECT_EXTRACTION = 'INCORRECT_EXTRACTION',
  MISSING_ERROR = 'MISSING_ERROR',
  NUMERIC_ERROR = 'NUMERIC_ERROR',
  PARTIAL_EXTRACTION = 'PARTIAL_EXTRACTION'
}

export type ClassificationTypeCount = {
  __typename?: 'ClassificationTypeCount';
  count: Scalars['Int']['output'];
  type: ClassificationType;
};

export type ClassificationWeight = {
  __typename?: 'ClassificationWeight';
  classification: ClassificationType;
  label: Scalars['String']['output'];
  weight: Scalars['Float']['output'];
};

export enum DataType {
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  JSON = 'JSON',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT'
}

export type Datapoint = {
  __typename?: 'Datapoint';
  dataType?: Maybe<DataType>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sourceType?: Maybe<SourceType>;
};

export type DateRange = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Document = {
  __typename?: 'Document';
  companyName?: Maybe<Scalars['String']['output']>;
  fundName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orgId: Scalars['ID']['output'];
  type?: Maybe<DocumentType>;
};

export enum DocumentType {
  CLOSING_MEMO = 'CLOSING_MEMO',
  OTHER = 'OTHER',
  TEARSHEET = 'TEARSHEET'
}

export type ErrorAnalysis = {
  __typename?: 'ErrorAnalysis';
  affectedDocuments: Array<Document>;
  errorBreakdown: Array<ErrorSlice>;
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  personId: Scalars['ID']['output'];
  totalErrors: Scalars['Int']['output'];
};

export type ErrorSlice = {
  __typename?: 'ErrorSlice';
  documentsAffected: Scalars['Int']['output'];
  errorType: ClassificationType;
  fieldsAffected: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  total: Scalars['Int']['output'];
  weight: Scalars['Float']['output'];
};

export type Evaluation = {
  __typename?: 'Evaluation';
  aiModel?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<ClassificationType>;
  classificationConfidence?: Maybe<Scalars['Float']['output']>;
  classificationReason?: Maybe<Scalars['String']['output']>;
  classifiedAt?: Maybe<Scalars['DateTime']['output']>;
  datapoint: Datapoint;
  document: Document;
  field: Field;
  finalValue?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ingestionRunId: Scalars['ID']['output'];
  isFinal: Scalars['Boolean']['output'];
  orgId: Scalars['ID']['output'];
  person: Person;
  previousValue?: Maybe<Scalars['String']['output']>;
  role: Role;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type EvaluationConnection = {
  __typename?: 'EvaluationConnection';
  edges: Array<EvaluationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EvaluationEdge = {
  __typename?: 'EvaluationEdge';
  cursor: Scalars['String']['output'];
  node: Evaluation;
};

export type EvaluationFilter = {
  classifications?: InputMaybe<Array<ClassificationType>>;
  datapointIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateRange?: InputMaybe<DateRange>;
  documentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fieldIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isFinal?: InputMaybe<Scalars['Boolean']['input']>;
  minDocuments?: InputMaybe<Scalars['Int']['input']>;
  minFields?: InputMaybe<Scalars['Int']['input']>;
  orgId: Scalars['ID']['input'];
  personId?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Role>;
};

export type Field = {
  __typename?: 'Field';
  category?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  masterFieldId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type FilterOptions = {
  __typename?: 'FilterOptions';
  analysts: Array<Person>;
  classificationWeights: Array<ClassificationWeight>;
  classifications: Array<ClassificationType>;
  documents: Array<Document>;
  fields: Array<Field>;
  maxDate?: Maybe<Scalars['Date']['output']>;
  minDate?: Maybe<Scalars['Date']['output']>;
  reviewers: Array<Person>;
};

export type IngestionInput = {
  artifactId?: InputMaybe<Scalars['ID']['input']>;
  chunkDuration?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  mode: IngestionMode;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  windowMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export enum IngestionMode {
  ARTIFACT = 'ARTIFACT',
  BACKFILL = 'BACKFILL',
  INCREMENTAL = 'INCREMENTAL'
}

export type IngestionResult = {
  __typename?: 'IngestionResult';
  dryRun: Scalars['Boolean']['output'];
  duration: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  estimatedRecords?: Maybe<Scalars['Int']['output']>;
  factsCreated: Scalars['Int']['output'];
  mode: IngestionMode;
  runId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  windowEnd?: Maybe<Scalars['DateTime']['output']>;
  windowStart?: Maybe<Scalars['DateTime']['output']>;
};

export type IngestionRunStatus = {
  __typename?: 'IngestionRunStatus';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  factsCreated: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: IngestionStatus;
  windowEnd?: Maybe<Scalars['DateTime']['output']>;
  windowStart?: Maybe<Scalars['DateTime']['output']>;
};

export enum IngestionStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  RUNNING = 'RUNNING'
}

export type Mutation = {
  __typename?: 'Mutation';
  runClassification: ClassificationResult;
  runIngestion: IngestionResult;
};


export type MutationRunClassificationArgs = {
  input: ClassificationInput;
};


export type MutationRunIngestionArgs = {
  input: IngestionInput;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PerformanceConnection = {
  __typename?: 'PerformanceConnection';
  edges: Array<PerformanceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PerformanceEdge = {
  __typename?: 'PerformanceEdge';
  cursor: Scalars['String']['output'];
  node: PerformanceMetrics;
};

export type PerformanceFilter = {
  classifications?: InputMaybe<Array<ClassificationType>>;
  dateRange?: InputMaybe<DateRange>;
  documentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fieldIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  minDocuments?: InputMaybe<Scalars['Int']['input']>;
  minPerformancePercent?: InputMaybe<Scalars['Float']['input']>;
  orgId: Scalars['ID']['input'];
  personIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  role?: InputMaybe<Role>;
};

export type PerformanceMetrics = {
  dailyVelocity: Scalars['Float']['output'];
  errorBreakdown: Array<ErrorSlice>;
  orgId: Scalars['ID']['output'];
  performancePercent: Scalars['Float']['output'];
  personEmail?: Maybe<Scalars['String']['output']>;
  personId: Scalars['ID']['output'];
  personName: Scalars['String']['output'];
  scorePerformance: Scalars['Float']['output'];
  totalCorrect: Scalars['Int']['output'];
  totalDatapoints: Scalars['Int']['output'];
  totalDocuments: Scalars['Int']['output'];
  totalErrors: Scalars['Int']['output'];
  totalFields: Scalars['Int']['output'];
};

export type PerformanceSummary = {
  __typename?: 'PerformanceSummary';
  performancePercent: Scalars['Float']['output'];
  role?: Maybe<Role>;
  totalCorrect: Scalars['Int']['output'];
  totalDatapoints: Scalars['Int']['output'];
  totalDocuments: Scalars['Int']['output'];
  totalErrors: Scalars['Int']['output'];
  totalFields: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
  velocity: Scalars['Float']['output'];
  windowEnd: Scalars['DateTime']['output'];
  windowStart: Scalars['DateTime']['output'];
};

export type Person = {
  __typename?: 'Person';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ProductivityConnection = {
  __typename?: 'ProductivityConnection';
  groupBy: TimeGrouping;
  points: Array<ProductivityPoint>;
};

export type ProductivityPoint = {
  __typename?: 'ProductivityPoint';
  datapointsCompleted: Scalars['Int']['output'];
  date: Scalars['Date']['output'];
  documentsCompleted: Scalars['Int']['output'];
  fieldsCompleted: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  errorAnalysis: ErrorAnalysis;
  evaluations: EvaluationConnection;
  filterOptions: FilterOptions;
  ingestionStatus: Array<IngestionRunStatus>;
  performanceDetails: PerformanceConnection;
  performanceSummary: PerformanceSummary;
  productivityTrends: ProductivityConnection;
};


export type QueryErrorAnalysisArgs = {
  filter: EvaluationFilter;
  personId: Scalars['ID']['input'];
};


export type QueryEvaluationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter: EvaluationFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFilterOptionsArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryIngestionStatusArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPerformanceDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter: PerformanceFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPerformanceSummaryArgs = {
  filter: PerformanceFilter;
};


export type QueryProductivityTrendsArgs = {
  filter: TimeFilter;
};

export type ReviewerPerformance = PerformanceMetrics & {
  __typename?: 'ReviewerPerformance';
  avgReviewTimeMinutes: Scalars['Float']['output'];
  dailyVelocity: Scalars['Float']['output'];
  errorBreakdown: Array<ErrorSlice>;
  orgId: Scalars['ID']['output'];
  performancePercent: Scalars['Float']['output'];
  personEmail?: Maybe<Scalars['String']['output']>;
  personId: Scalars['ID']['output'];
  personName: Scalars['String']['output'];
  reviewDays: Scalars['Int']['output'];
  scorePerformance: Scalars['Float']['output'];
  totalCorrect: Scalars['Int']['output'];
  totalDatapoints: Scalars['Int']['output'];
  totalDocuments: Scalars['Int']['output'];
  totalErrors: Scalars['Int']['output'];
  totalFields: Scalars['Int']['output'];
};

export enum Role {
  ANALYST = 'ANALYST',
  MANAGER = 'MANAGER',
  REVIEWER = 'REVIEWER',
  UNKNOWN = 'UNKNOWN'
}

export enum SourceType {
  AI = 'AI',
  IMPORT = 'IMPORT',
  MANUAL = 'MANUAL'
}

export type TimeFilter = {
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<TimeGrouping>;
  minFields?: InputMaybe<Scalars['Int']['input']>;
  orgId: Scalars['ID']['input'];
  role?: InputMaybe<Role>;
};

export enum TimeGrouping {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY'
}

export type ErrorAnalysisQueryVariables = Exact<{
  personId: Scalars['ID']['input'];
  filter: EvaluationFilter;
}>;


export type ErrorAnalysisQuery = (
  { __typename?: 'Query' }
  & { errorAnalysis: (
    { __typename?: 'ErrorAnalysis' }
    & Pick<ErrorAnalysis, 'personId' | 'totalErrors' | 'lastActiveAt'>
    & { errorBreakdown: Array<(
      { __typename?: 'ErrorSlice' }
      & Pick<ErrorSlice, 'errorType' | 'weight' | 'total' | 'percentage' | 'documentsAffected' | 'fieldsAffected'>
    )>, affectedDocuments: Array<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'name' | 'type' | 'companyName' | 'fundName'>
    )> }
  ) }
);

export type EvaluationsQueryVariables = Exact<{
  filter: EvaluationFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type EvaluationsQuery = (
  { __typename?: 'Query' }
  & { evaluations: (
    { __typename?: 'EvaluationConnection' }
    & Pick<EvaluationConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'EvaluationEdge' }
      & Pick<EvaluationEdge, 'cursor'>
      & { node: (
        { __typename?: 'Evaluation' }
        & Pick<Evaluation, 'id' | 'orgId' | 'role' | 'value' | 'previousValue' | 'finalValue' | 'isFinal' | 'classification' | 'classificationReason' | 'classificationConfidence' | 'aiModel' | 'submittedAt' | 'classifiedAt' | 'ingestionRunId'>
        & { person: (
          { __typename?: 'Person' }
          & Pick<Person, 'id' | 'name' | 'email'>
        ), document: (
          { __typename?: 'Document' }
          & Pick<Document, 'id' | 'name' | 'type' | 'companyName' | 'fundName'>
        ), field: (
          { __typename?: 'Field' }
          & Pick<Field, 'id' | 'name' | 'displayName' | 'type' | 'category'>
        ), datapoint: (
          { __typename?: 'Datapoint' }
          & Pick<Datapoint, 'id' | 'name' | 'displayName' | 'dataType' | 'sourceType'>
        ) }
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type FilterOptionsQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type FilterOptionsQuery = (
  { __typename?: 'Query' }
  & { filterOptions: (
    { __typename?: 'FilterOptions' }
    & Pick<FilterOptions, 'classifications' | 'minDate' | 'maxDate'>
    & { documents: Array<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'name' | 'type'>
    )>, fields: Array<(
      { __typename?: 'Field' }
      & Pick<Field, 'id' | 'name' | 'displayName' | 'type' | 'category'>
    )>, classificationWeights: Array<(
      { __typename?: 'ClassificationWeight' }
      & Pick<ClassificationWeight, 'classification' | 'weight' | 'label'>
    )>, analysts: Array<(
      { __typename?: 'Person' }
      & Pick<Person, 'id' | 'name' | 'email'>
    )>, reviewers: Array<(
      { __typename?: 'Person' }
      & Pick<Person, 'id' | 'name' | 'email'>
    )> }
  ) }
);

export type IngestionStatusQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type IngestionStatusQuery = (
  { __typename?: 'Query' }
  & { ingestionStatus: Array<(
    { __typename?: 'IngestionRunStatus' }
    & Pick<IngestionRunStatus, 'id' | 'startedAt' | 'completedAt' | 'windowStart' | 'windowEnd' | 'factsCreated' | 'status' | 'errorMessage'>
  )> }
);

export type PerformanceDetailsQueryVariables = Exact<{
  filter: PerformanceFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type PerformanceDetailsQuery = (
  { __typename?: 'Query' }
  & { performanceDetails: (
    { __typename?: 'PerformanceConnection' }
    & Pick<PerformanceConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'PerformanceEdge' }
      & Pick<PerformanceEdge, 'cursor'>
      & { node: (
        { __typename?: 'AnalystPerformance' }
        & Pick<AnalystPerformance, 'workDays' | 'personId' | 'personName' | 'personEmail' | 'orgId' | 'totalDocuments' | 'totalFields' | 'totalDatapoints' | 'totalErrors' | 'performancePercent' | 'scorePerformance'>
        & { errorBreakdown: Array<(
          { __typename?: 'ErrorSlice' }
          & Pick<ErrorSlice, 'errorType' | 'weight' | 'total' | 'percentage' | 'documentsAffected' | 'fieldsAffected'>
        )> }
      ) | (
        { __typename?: 'ReviewerPerformance' }
        & Pick<ReviewerPerformance, 'reviewDays' | 'avgReviewTimeMinutes' | 'personId' | 'personName' | 'personEmail' | 'orgId' | 'totalDocuments' | 'totalFields' | 'totalDatapoints' | 'totalErrors' | 'performancePercent' | 'scorePerformance'>
        & { errorBreakdown: Array<(
          { __typename?: 'ErrorSlice' }
          & Pick<ErrorSlice, 'errorType' | 'weight' | 'total' | 'percentage' | 'documentsAffected' | 'fieldsAffected'>
        )> }
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type PerformanceSummaryQueryVariables = Exact<{
  filter: PerformanceFilter;
}>;


export type PerformanceSummaryQuery = (
  { __typename?: 'Query' }
  & { performanceSummary: (
    { __typename?: 'PerformanceSummary' }
    & Pick<PerformanceSummary, 'role' | 'totalUsers' | 'totalDocuments' | 'totalFields' | 'totalDatapoints' | 'totalCorrect' | 'totalErrors' | 'performancePercent' | 'windowStart' | 'windowEnd'>
  ) }
);

export type ProductivityTrendsQueryVariables = Exact<{
  filter: TimeFilter;
}>;


export type ProductivityTrendsQuery = (
  { __typename?: 'Query' }
  & { productivityTrends: (
    { __typename?: 'ProductivityConnection' }
    & Pick<ProductivityConnection, 'groupBy'>
    & { points: Array<(
      { __typename?: 'ProductivityPoint' }
      & Pick<ProductivityPoint, 'date' | 'fieldsCompleted' | 'datapointsCompleted' | 'documentsCompleted'>
    )> }
  ) }
);


export const ErrorAnalysisDocument = gql`
    query ErrorAnalysis($personId: ID!, $filter: EvaluationFilter!) {
  errorAnalysis(personId: $personId, filter: $filter) {
    personId
    totalErrors
    lastActiveAt
    errorBreakdown {
      errorType
      weight
      total
      percentage
      documentsAffected
      fieldsAffected
    }
    affectedDocuments {
      id
      name
      type
      companyName
      fundName
    }
  }
}
    `;

/**
 * __useErrorAnalysisQuery__
 *
 * To run a query within a React component, call `useErrorAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useErrorAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErrorAnalysisQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useErrorAnalysisQuery(baseOptions: Apollo.QueryHookOptions<ErrorAnalysisQuery, ErrorAnalysisQueryVariables> & ({ variables: ErrorAnalysisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErrorAnalysisQuery, ErrorAnalysisQueryVariables>(ErrorAnalysisDocument, options);
      }
export function useErrorAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErrorAnalysisQuery, ErrorAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErrorAnalysisQuery, ErrorAnalysisQueryVariables>(ErrorAnalysisDocument, options);
        }
export function useErrorAnalysisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ErrorAnalysisQuery, ErrorAnalysisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ErrorAnalysisQuery, ErrorAnalysisQueryVariables>(ErrorAnalysisDocument, options);
        }
export type ErrorAnalysisQueryHookResult = ReturnType<typeof useErrorAnalysisQuery>;
export type ErrorAnalysisLazyQueryHookResult = ReturnType<typeof useErrorAnalysisLazyQuery>;
export type ErrorAnalysisSuspenseQueryHookResult = ReturnType<typeof useErrorAnalysisSuspenseQuery>;
export type ErrorAnalysisQueryResult = Apollo.QueryResult<ErrorAnalysisQuery, ErrorAnalysisQueryVariables>;
export const EvaluationsDocument = gql`
    query Evaluations($filter: EvaluationFilter!, $first: Int, $after: String) {
  evaluations(filter: $filter, first: $first, after: $after) {
    edges {
      cursor
      node {
        id
        orgId
        role
        person {
          id
          name
          email
        }
        document {
          id
          name
          type
          companyName
          fundName
        }
        field {
          id
          name
          displayName
          type
          category
        }
        datapoint {
          id
          name
          displayName
          dataType
          sourceType
        }
        value
        previousValue
        finalValue
        isFinal
        classification
        classificationReason
        classificationConfidence
        aiModel
        submittedAt
        classifiedAt
        ingestionRunId
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useEvaluationsQuery__
 *
 * To run a query within a React component, call `useEvaluationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useEvaluationsQuery(baseOptions: Apollo.QueryHookOptions<EvaluationsQuery, EvaluationsQueryVariables> & ({ variables: EvaluationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EvaluationsQuery, EvaluationsQueryVariables>(EvaluationsDocument, options);
      }
export function useEvaluationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EvaluationsQuery, EvaluationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EvaluationsQuery, EvaluationsQueryVariables>(EvaluationsDocument, options);
        }
export function useEvaluationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EvaluationsQuery, EvaluationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EvaluationsQuery, EvaluationsQueryVariables>(EvaluationsDocument, options);
        }
export type EvaluationsQueryHookResult = ReturnType<typeof useEvaluationsQuery>;
export type EvaluationsLazyQueryHookResult = ReturnType<typeof useEvaluationsLazyQuery>;
export type EvaluationsSuspenseQueryHookResult = ReturnType<typeof useEvaluationsSuspenseQuery>;
export type EvaluationsQueryResult = Apollo.QueryResult<EvaluationsQuery, EvaluationsQueryVariables>;
export const FilterOptionsDocument = gql`
    query FilterOptions($orgId: ID!) {
  filterOptions(orgId: $orgId) {
    documents {
      id
      name
      type
    }
    fields {
      id
      name
      displayName
      type
      category
    }
    classifications
    classificationWeights {
      classification
      weight
      label
    }
    analysts {
      id
      name
      email
    }
    reviewers {
      id
      name
      email
    }
    minDate
    maxDate
  }
}
    `;

/**
 * __useFilterOptionsQuery__
 *
 * To run a query within a React component, call `useFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterOptionsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<FilterOptionsQuery, FilterOptionsQueryVariables> & ({ variables: FilterOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterOptionsQuery, FilterOptionsQueryVariables>(FilterOptionsDocument, options);
      }
export function useFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterOptionsQuery, FilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterOptionsQuery, FilterOptionsQueryVariables>(FilterOptionsDocument, options);
        }
export function useFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FilterOptionsQuery, FilterOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FilterOptionsQuery, FilterOptionsQueryVariables>(FilterOptionsDocument, options);
        }
export type FilterOptionsQueryHookResult = ReturnType<typeof useFilterOptionsQuery>;
export type FilterOptionsLazyQueryHookResult = ReturnType<typeof useFilterOptionsLazyQuery>;
export type FilterOptionsSuspenseQueryHookResult = ReturnType<typeof useFilterOptionsSuspenseQuery>;
export type FilterOptionsQueryResult = Apollo.QueryResult<FilterOptionsQuery, FilterOptionsQueryVariables>;
export const IngestionStatusDocument = gql`
    query IngestionStatus($limit: Int) {
  ingestionStatus(limit: $limit) {
    id
    startedAt
    completedAt
    windowStart
    windowEnd
    factsCreated
    status
    errorMessage
  }
}
    `;

/**
 * __useIngestionStatusQuery__
 *
 * To run a query within a React component, call `useIngestionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useIngestionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIngestionStatusQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useIngestionStatusQuery(baseOptions?: Apollo.QueryHookOptions<IngestionStatusQuery, IngestionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IngestionStatusQuery, IngestionStatusQueryVariables>(IngestionStatusDocument, options);
      }
export function useIngestionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IngestionStatusQuery, IngestionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IngestionStatusQuery, IngestionStatusQueryVariables>(IngestionStatusDocument, options);
        }
export function useIngestionStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IngestionStatusQuery, IngestionStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IngestionStatusQuery, IngestionStatusQueryVariables>(IngestionStatusDocument, options);
        }
export type IngestionStatusQueryHookResult = ReturnType<typeof useIngestionStatusQuery>;
export type IngestionStatusLazyQueryHookResult = ReturnType<typeof useIngestionStatusLazyQuery>;
export type IngestionStatusSuspenseQueryHookResult = ReturnType<typeof useIngestionStatusSuspenseQuery>;
export type IngestionStatusQueryResult = Apollo.QueryResult<IngestionStatusQuery, IngestionStatusQueryVariables>;
export const PerformanceDetailsDocument = gql`
    query PerformanceDetails($filter: PerformanceFilter!, $first: Int, $after: String) {
  performanceDetails(filter: $filter, first: $first, after: $after) {
    edges {
      cursor
      node {
        personId
        personName
        personEmail
        orgId
        totalDocuments
        totalFields
        totalDatapoints
        totalErrors
        performancePercent
        scorePerformance
        errorBreakdown {
          errorType
          weight
          total
          percentage
          documentsAffected
          fieldsAffected
        }
        ... on AnalystPerformance {
          workDays
        }
        ... on ReviewerPerformance {
          reviewDays
          avgReviewTimeMinutes
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __usePerformanceDetailsQuery__
 *
 * To run a query within a React component, call `usePerformanceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceDetailsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePerformanceDetailsQuery(baseOptions: Apollo.QueryHookOptions<PerformanceDetailsQuery, PerformanceDetailsQueryVariables> & ({ variables: PerformanceDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PerformanceDetailsQuery, PerformanceDetailsQueryVariables>(PerformanceDetailsDocument, options);
      }
export function usePerformanceDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PerformanceDetailsQuery, PerformanceDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PerformanceDetailsQuery, PerformanceDetailsQueryVariables>(PerformanceDetailsDocument, options);
        }
export function usePerformanceDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerformanceDetailsQuery, PerformanceDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PerformanceDetailsQuery, PerformanceDetailsQueryVariables>(PerformanceDetailsDocument, options);
        }
export type PerformanceDetailsQueryHookResult = ReturnType<typeof usePerformanceDetailsQuery>;
export type PerformanceDetailsLazyQueryHookResult = ReturnType<typeof usePerformanceDetailsLazyQuery>;
export type PerformanceDetailsSuspenseQueryHookResult = ReturnType<typeof usePerformanceDetailsSuspenseQuery>;
export type PerformanceDetailsQueryResult = Apollo.QueryResult<PerformanceDetailsQuery, PerformanceDetailsQueryVariables>;
export const PerformanceSummaryDocument = gql`
    query PerformanceSummary($filter: PerformanceFilter!) {
  performanceSummary(filter: $filter) {
    role
    totalUsers
    totalDocuments
    totalFields
    totalDatapoints
    totalCorrect
    totalErrors
    performancePercent
    windowStart
    windowEnd
  }
}
    `;

/**
 * __usePerformanceSummaryQuery__
 *
 * To run a query within a React component, call `usePerformanceSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceSummaryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePerformanceSummaryQuery(baseOptions: Apollo.QueryHookOptions<PerformanceSummaryQuery, PerformanceSummaryQueryVariables> & ({ variables: PerformanceSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PerformanceSummaryQuery, PerformanceSummaryQueryVariables>(PerformanceSummaryDocument, options);
      }
export function usePerformanceSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PerformanceSummaryQuery, PerformanceSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PerformanceSummaryQuery, PerformanceSummaryQueryVariables>(PerformanceSummaryDocument, options);
        }
export function usePerformanceSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerformanceSummaryQuery, PerformanceSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PerformanceSummaryQuery, PerformanceSummaryQueryVariables>(PerformanceSummaryDocument, options);
        }
export type PerformanceSummaryQueryHookResult = ReturnType<typeof usePerformanceSummaryQuery>;
export type PerformanceSummaryLazyQueryHookResult = ReturnType<typeof usePerformanceSummaryLazyQuery>;
export type PerformanceSummarySuspenseQueryHookResult = ReturnType<typeof usePerformanceSummarySuspenseQuery>;
export type PerformanceSummaryQueryResult = Apollo.QueryResult<PerformanceSummaryQuery, PerformanceSummaryQueryVariables>;
export const ProductivityTrendsDocument = gql`
    query ProductivityTrends($filter: TimeFilter!) {
  productivityTrends(filter: $filter) {
    groupBy
    points {
      date
      fieldsCompleted
      datapointsCompleted
      documentsCompleted
    }
  }
}
    `;

/**
 * __useProductivityTrendsQuery__
 *
 * To run a query within a React component, call `useProductivityTrendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductivityTrendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductivityTrendsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProductivityTrendsQuery(baseOptions: Apollo.QueryHookOptions<ProductivityTrendsQuery, ProductivityTrendsQueryVariables> & ({ variables: ProductivityTrendsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductivityTrendsQuery, ProductivityTrendsQueryVariables>(ProductivityTrendsDocument, options);
      }
export function useProductivityTrendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductivityTrendsQuery, ProductivityTrendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductivityTrendsQuery, ProductivityTrendsQueryVariables>(ProductivityTrendsDocument, options);
        }
export function useProductivityTrendsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductivityTrendsQuery, ProductivityTrendsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductivityTrendsQuery, ProductivityTrendsQueryVariables>(ProductivityTrendsDocument, options);
        }
export type ProductivityTrendsQueryHookResult = ReturnType<typeof useProductivityTrendsQuery>;
export type ProductivityTrendsLazyQueryHookResult = ReturnType<typeof useProductivityTrendsLazyQuery>;
export type ProductivityTrendsSuspenseQueryHookResult = ReturnType<typeof useProductivityTrendsSuspenseQuery>;
export type ProductivityTrendsQueryResult = Apollo.QueryResult<ProductivityTrendsQuery, ProductivityTrendsQueryVariables>;